import { useRouter } from '#pplx/frontend/router/provider.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
export const useAllowedFloatingUpsellPath = () => {
    const { base } = useRouter();
    const pathname = usePathname();
    return pathname === (base || '/');
};
//# sourceMappingURL=useAllowedFloatingUpsellPath.js.map